import moment from 'moment-timezone';

/**
 * Checks if user account, given the date of creation is older than 30 days
 * @example
 *
 * timestamp = '2023-06-01T12:00:00Z';
 * isOlderThan30Days(timestamp) // outputs: true
 * @param {*} timestamp
 * @returns
 */
function isOlderThan30Days(timestamp) {
  const givenDate = moment(timestamp);
  const thirtyDaysAgo = moment().subtract(30, 'days');
  return givenDate.isBefore(thirtyDaysAgo);
}

export function requiresEmailVerification(user) {
  if (!user) {
    return true;
  }
  /** Previous users w/ account older than 30 days from today and email isn't verified */
  const isPreviousUser = isOlderThan30Days(user.createdOn) && !user.isVerified;

  return !isPreviousUser && !user.isVerified;
}
